module.exports = __webpack_public_path__ + "static/media/COBRE.0e06f3a6.jpg";